<!-- eslint-disable no-new -->
<script lang="ts" setup>
import { useCMSQuery } from '@develop/ia-api-library'
import type { GetEpaperApofinderConfigQuery } from '~/models/generated/cms'
import { GetEpaperApofinderConfig as GetEpaperApofinderConfigDocument } from '~/models/generated/cms'

const elementId = 'ia-apofinder-widget'

const { isProd } = useEnvs()

const apiBase = computed(() => isProd.value ? 'https://ihreapotheken.de' : 'https://qa.ihreapotheken.de')
const widgetBase = computed(() => isProd.value ? 'https://ihreapotheken.de' : 'https://qa.ihreapotheken.de')
const apiBaseElastic = computed(() => isProd.value ? 'https://api.ia.de' : 'https://api-qa.ia.de')

const { load, unload } = useScriptTag(`${widgetBase.value}/widget/build/apofinder-v2/snippet.min.js`, () => {
}, { manual: true })

onMounted(async () => {
  const { data } = await useCMSQuery<GetEpaperApofinderConfigQuery>({ query: GetEpaperApofinderConfigDocument })
  const apofinderConfig = data.value?.magazineHomepage?.data?.attributes?.apofinderConfig
  if (apofinderConfig) {
    const config = {
      ...apofinderConfig,
      base: {
        apiBase: apiBase.value,
        widgetBase: widgetBase.value,
        apiBaseElastic: apiBaseElastic.value,
      },
      parameters: {
        ...apofinderConfig.options,
        headline: apofinderConfig.options?.headline ?? '',
        showGoogleMaps: true,
      },
      settings: {
        ...apofinderConfig.settings,
        locationMarkerIcon: `${widgetBase.value}/widget/build/images/location_here.svg`,
        pharmacyMarkerIcon: `${widgetBase.value}/widget/build/images/IA_pin2.png`,
      },
    }
    await load(true)
    new window.ApoFinderWidget(elementId, config) }
})
onBeforeUnmount(() => {
  unload()
})
</script>

<template>
  <div id="ia-apofinder-widget"></div>
</template>
